import { onMounted, onUnmounted, ref, type Ref } from 'vue';

// Shared reactive breakpoint — 641px is the shell's tablet threshold
// (AppShell's BottomNav/SideNav swap, ItemDetailView's inline form).
// SSR/test-safe: stays false when matchMedia is unavailable.
export function useTabletOrLarger(): Ref<boolean> {
  const isTabletOrLarger = ref(false);
  let mq: MediaQueryList | null = null;
  function onChange(e: MediaQueryListEvent | MediaQueryList): void {
    isTabletOrLarger.value = e.matches;
  }
  onMounted(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    mq = window.matchMedia('(min-width: 641px)');
    onChange(mq);
    mq.addEventListener('change', onChange);
  });
  onUnmounted(() => {
    if (mq) {
      mq.removeEventListener('change', onChange);
      mq = null;
    }
  });
  return isTabletOrLarger;
}
